
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(8 12)"}},[_c('circle',{attrs:{"cx":"31","cy":"19","r":"3","fill":"#FFF"}}),_c('path',{attrs:{"fill":"#F4FBFE","d":"M21.5 3.192v37.522h22.966v-24.15l-2.101-1.642V5.137h-4.204v7.488z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M26 32h14v8H26z"}}),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.102","d":"M.33 40.143h48.34M.33 23.329l21.017-8.407M4.534 21.688v18.455M18.195.21L48.67 19.126M44.466 16.564v23.579M38.161 12.625v-7.16c0-.58.47-1.051 1.051-1.051h2.102c.58 0 1.05.47 1.05 1.05v9.755M39.212 40.143c.58 0 1.05-.47 1.05-1.051v-6.305c0-.58-.47-1.051-1.05-1.051h-12.61c-.58 0-1.051.47-1.051 1.05v6.306c0 .58.47 1.05 1.05 1.05M33.958 31.736v8.407"}}),_c('path',{attrs:{"fill":"#FFF","stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.102","d":"M27.655 19.126a3.153 3.153 0 106.305 0 3.153 3.153 0 00-6.305 0h0z"}}),_c('path',{attrs:{"stroke":"#5FB8EE","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2.102","d":"M16.093 40.143c.58 0 1.051-.47 1.051-1.051v-8.407c0-.58-.47-1.05-1.05-1.05H9.787c-.58 0-1.05.47-1.05 1.05v8.407c0 .58.47 1.05 1.05 1.05M21.347 2.213v37.93"}})])])
          )
        }
      }
    